var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-modal',{attrs:{"no-esc-dismiss":true,"no-backdrop-dismiss":true},model:{value:(_vm.showLogin),callback:function ($$v) {_vm.showLogin=$$v},expression:"showLogin"}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-344a6480","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/auth/suspended.vue
// module id = ILUx
// module chunks = 60